import { ScrollView, View } from 'react-native';
import { Button, IconButton, Text, useTheme } from "react-native-paper";
import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import * as XLSX from "xlsx"
import Preferance from '../constants/Preferances';

import { MaterialIcons } from '@expo/vector-icons';
import Global from '../constants/global';
import { useSelector } from 'react-redux';

const pageStyle = `
  @media all {
    .pagebreak {
      display: none;
      page-break-after: always;
    }
  }

  @media print {
    .pagebreak {
      page-break-after: always;
    }
    /* This allows the browser to show the orientation toggle */
    @page { 
      size: auto; 
      margin: 20mm; 
    }
  }
`;export default function PrintSummarySheet({ navigation, route }) {
    const pref = useContext(Preferance)
    const S = useSelector(s => s.list.SummarySheet[route.params.classId + route.params.year + route.params.examName])
    const ref = useRef()
    const Row1 = ({ roll, gr, name, title, left }) => {
        const tt = title ? { textAlign: "center" } : { fontSize: 10 }
        return <><div style={{ textAlign: "center", display: "flex", width: 30, maxWidth: 30, borderWidth: 1, borderStyle: "solid" }}>{roll}</div>
            <div style={{ width: 40, maxWidth: 40, borderWidth: 1, borderStyle: "solid", textAlign: "center" }}>{gr}</div>
            <div style={{ width: 150, maxWidth: 150, borderWidth: 1, borderStyle: "solid", ...tt, textDecorationLine: left == true ? 'line-through' : "" }}>{name}</div></>
    }

    const Row2 = ({ value, title, status }) => {
        const tt = title ? { fontSize: 10 } : {}
        return <div style={{ width: 45, maxWidth: 45, borderWidth: 1, borderStyle: "solid", justifyContent: "center", alignItems: "center" }}>
            <div variant={"titleSmall"} style={{
                textAlign: "center", ...tt,
                textDecoration: (status == "Fail" && value !== "Ab") ? "underline" : "none",
                color: (status == "Fail" && value !== "Ab") ? "red" : undefined
            }}> {value}</div>
        </div>
    }

    const Row3 = ({ v1, v2, v3 }) => {
        return <><div variant={"titleMedium"} style={{ backgroundColor: "#DCDCDC", width: 60, borderWidth: 1, borderStyle: "solid", textAlign: "center", fontWeight: "900" }}>{v1}</div>
            <div variant={"titleMedium"} style={{
                backgroundColor: "#DCDCDC",
                width: 55, borderWidth: 1, borderStyle: "solid", textAlign: "center", fontWeight: "900"
            }}>{v2}</div>
            <div variant={"titleMedium"} style={{ backgroundColor: "#DCDCDC", width: 55, borderWidth: 1, borderStyle: "solid", textAlign: "center", fontWeight: "900" }}>{v3}</div></>
    }
    const t = useTheme()
    return <View>
        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", alignSelf: "flex-start" }}>
            {/* <IconButton icon={"arrow-left"} onPress={() => navigation.goBack()} /> */}
            <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => <div style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: t.colors.primary, color: t.colors.onPrimary, padding: 5, borderRadius: 5, paddingRight: 10 }}><MaterialIcons style={{ marginLeft: 5, marginRight: 5 }} name="print" color={t.colors.onPrimary} />Print</div>}
                content={() => ref.current}
            />
            {pref?.current.supervisor == true && <Button onPress={() => {
                try {
                    const workbook = XLSX.utils.book_new();
                    const headers = ["રોલ", "GR", "વિદ્યાર્થી નું નામ"]
                    value.subjects.map(s => headers.push(s.name))
                    headers.push("પરિણામ")
                    headers.push("મેળવેલ ગુણ")
                    headers.push("Rank")
                    const l2: [] = []
                    value?.sheet?.filter(e => e?.totalling !== true)?.map(s => {
                        const me = { "roll": s.student["class" + value.year]?.roll, gr: s.student["class" + value.year]?.gr, name: s.student.name + (Global.isLeft(s.student, value.year) ? "(Left)" : "") }
                        value.subjects.map(e => {
                            const vv = s.subject.find(f => f?.subject_id == e.id)
                            if (vv) {
                                me[e.name] = Global.getValue(vv, "Ab")
                            } else {
                                me[e.name] = ""
                            }
                        }
                        )
                        me.status = Global.isLeft(s.student, value.year) ? "Left" : Global.getResultStatus(s.examObject.status)
                        me.marks = s.examObject.subjectMarks
                        me.rank = s.examObject.rank ? s.examObject.rank : ""
                        l2.push(me)
                    })
                    const worksheet = XLSX.utils.json_to_sheet(l2)
                    //console.log(l2)
                    XLSX.utils.book_append_sheet(workbook, worksheet, "SummarySheet");
                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
                    XLSX.writeFile(workbook, "SummarySheet" + value.class.name + (value.class.div ? " " + value.class.div : "") + ".xlsx");
                } catch (e) {
                    //console.log("me the e", e)
                    alert("error")
                }
            }}>Export</Button>}
        </View>
        <View>
            <div ref={ref} style={{ display: "block", width: "98%", marginLeft: 10, boxSizing: "border-box" }}>
                
                <View style={{ paddingLeft: 60 }}>
                    <Text variant="displaySmall" style={{ fontWeight: "bold", flex: 1, textAlign: "center", marginTop: 20, }}>{"શ્રી ઠક્કરબાપા વિદ્યામંદિર"}</Text>
                    <View style={{ flexDirection: "row", }}>
                        <Text variant="titleLarge" style={{ textAlign: "center", flex: 1 }} >Summary Sheet</Text>
                        <Text variant="titleLarge" style={{ textAlign: "center", flex: 1 }} >{S?.className} {S?.div}</Text>
                        <Text variant="titleLarge" style={{ textAlign: "center", flex: 1 }} >{S?.examName} {S?.year}</Text>
                    </View>
                </View>

                <View>
                    <table style={{ paddingLeft: 60, width: "100%", paddingRight: 20 }}>
                        <thead style={{ padding: 0, margin: 0 }}>
                            <div style={{ display: "flex", pageBreakInside: "avoid", flexDirection: "row", marginTop: 30 }}>
                                <Row1 roll={"રોલ"} gr={"GR"} name={"વિદ્યાર્થી નું નામ"} title={true} />
                                {
                                    S?.subjectNames.map(e => {
                                        return <Row2 value={e.name} title={true} />
                                    })
                                }
                                <Row3 v1={"પરિણામ"} v2={"મેળવેલ ગુણ"} v3={"Rank"} />
                            </div>
                        </thead>
                        <tbody style={{ padding: 0, margin: 0 }}>
                            {

                                S?.studentList?.map(st => {

                                    const left = st.left
                                    const sList: [] = []
                                    S?.subjectNames.map(key => {
                                        sList.push(st.subjectMarks[key.id])
                                    })
                                    ////console.log("St", st, sList, S?.subjectNames)

                                    return <div style={{ display: "flex", pageBreakInside: "avoid", flexDirection: "row" }}>
                                        <Row1 roll={st?.roll} gr={st?.gr} name={st.name + (left ? "(Left)" : "")} title={false} left={left} />
                                        {
                                            sList.map(e => {
                                                return <Row2
                                                    value={e.marks}
                                                    title={false}
                                                    status={left ? "Left" : e.status} />
                                            }
                                            )
                                        }
                                        < Row3 v1={left ? "Left" : Global.getResultStatus(st?.status)} v2={st.totalMarks} v3={st.rank} />
                                    </div>
                                })

                            }
                        </tbody>
                    </table>
                </View>
            </div>
        </View >
    </View>
}